import script from "./Toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=f5863848&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5863848"]])

export default __exports__